module.exports = __webpack_public_path__ + "img/window.6ba35d88.svg";